// extracted by mini-css-extract-plugin
export var box = "_4u-1";
export var checkboxRow = "_4u-8";
export var checked = "_4u-2";
export var descriptionSpacer = "_4u-a";
export var disabled = "_4u-3";
export var icon = "_4u-6";
export var input = "_4u-0";
export var labelSpacer = "_4u-9";
export var medium = "_4u-5";
export var small = "_4u-4";
export var text = "_4u-7";